import * as commonFields from "./common-fields";
import type { BaseDditDto } from "@ckweb/ckfetch/connectables/taskListManagement";

type DailyDutyItem = BaseDditDto & {
  number?: number;
};

export const dailyDutySchema: $ck.z.ZodType<DailyDutyItem> = $ck.z.object({
  number: commonFields.optionalNumberField(),
  name: commonFields.requiredStringField(),
  active: commonFields.booleanField(),
  forecastMinutes: commonFields.requiredNumberField(),
  equip: commonFields.requiredNumericListItemField(),
  equipName: commonFields.requiredStringListItemField(),
  pdfName: commonFields.stringOrEmptyField(),
  skill: commonFields.stringOrEmptyListItemField(),
});

export type DailyDutySchema = $ck.z.TypeOf<typeof dailyDutySchema>;
